import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enLang from './en/translation.json';
import esLang from './es/translation.json';

i18n
  // connect with React
  .use(LanguageDetector)
  .use(initReactI18next)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    detection: {
      lookupLocalStorage: 'i18nextLng',
    },
    lng: 'es',
    debug: false,
    resources: {
      en: {
        translation: enLang,
      },
      es: {
        translation: esLang,
      },
    },
    fallbackLng: 'en',
    whitelist: ['es', 'en'],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      wait: true,
    },
  });

export default i18n;
